import { cloneElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonRadio } from '@/components'

import { ModelRoute } from '../types'
import { RouteApiAccess } from './RouteApiAccess'
import { RouteBilling } from './RouteBilling'
import { RouteModelList } from './RouteModelList'
import { RouteMonitor } from './RouteMonitor'
import { RouteOverview } from './RouteOverview'

interface ModelRouteDetailProps {
  route: ModelRoute
}

export function ModelRouteDetail({ route }: ModelRouteDetailProps) {
  const { t } = useTranslation('modelRoute')

  const items = [
    {
      label: t('detail.tabOverview', 'Overview'),
      value: 'Overview',
      Comp: <RouteOverview route={route} />,
    },
    {
      label: t('detail.tabModelList', 'Model List'),
      value: 'ModelList',
      Comp: <RouteModelList route={route} />,
    },
    {
      label: t('detail.tabApiAccess', 'API Access'),
      value: 'ApiAccess',
      Comp: <RouteApiAccess route={route} />,
    },
    {
      label: t('detail.tabBilling', 'Billing'),
      value: 'Billing',
      Comp: <RouteBilling route={route} />,
    },
    {
      label: t('detail.tabMonitor', 'Monitor'),
      value: 'Monitor',
      Comp: <RouteMonitor route={route} />,
    },
  ]

  const [tab, setTab] = useState(items[0].value)

  return (
    <div>
      <div className="px-4">
        <ButtonRadio
          className="mb-2"
          value={tab}
          items={items}
          onChange={(e) => setTab(e)}
          size={'small'}
        />

        {items.map((item) => tab === item.value && cloneElement(item.Comp, { key: item.value }))}
      </div>
    </div>
  )
}
